import TemplateLibraryContainer from './TemplateLibrary.container.v2.js'
import TemplateLibraryView from './TemplateLibrary.view.vue'

export default TemplateLibraryContainer(TemplateLibraryView)
